import { render, staticRenderFns } from "./dados_cadastrais.vue?vue&type=template&id=b1bd81a0&scoped=true&"
import script from "./dados_cadastrais.vue?vue&type=script&lang=js&"
export * from "./dados_cadastrais.vue?vue&type=script&lang=js&"
import style0 from "./dados_cadastrais.vue?vue&type=style&index=0&id=b1bd81a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1bd81a0",
  null
  
)

export default component.exports